import React from "react";

const RightSmallMenuBar = (props: any) => {
  return (
    <div className="small-bar-right">
      <div className="small-bar-title">
        {props.selectedItemNm.split(" ").map((text: any, index: any) => (
          <span key={index} id="font-SCD6">
            {text} {index === 0 && <br></br>}
          </span>
        ))}
      </div>
      <div className="small-bar-btn-form">
        <div style={{ margin: "10px 0" }}></div>
        <div style={{ textAlign: "center", padding: "0 10px" }}>
          <div
            style={{ float: "left", width: "50px", cursor: "pointer" }}
            onClick={() => props.goTop()}
          >
            <span>▲</span>
            <br></br>
            <span>맨위로</span>
          </div>
          <div
            style={{ float: "right", width: "50px", cursor: "pointer" }}
            onClick={() => props.goBottom()}
          >
            <span>▼</span>
            <br></br>
            <span>맨아래로</span>
          </div>
        </div>
        {/* <div style={{ textAlign: "center" }}>

          <span style={{ marginRight: "35px" }} onClick={() => props.goTop()}>
            ▲
          </span>
          <span onClick={() => props.goBottom()}>▼</span>
        </div>
        <div style={{ textAlign: "center" }}>
          <span style={{ marginRight: "8px" }} onClick={() => props.goTop()}>
            맨위로
          </span>
          <span onClick={() => props.goBottom()}>맨아래로</span>
        </div> */}
        <div style={{ clear: "both" }}></div>
        <div style={{ margin: "10px 0" }}></div>
        <div>
          <button
            className="buy"
            onClick={() => window.open(props.buySite)}
            id="font-SCD5"
          >
            구매
          </button>
          <button
            className="search"
            onClick={() => window.open(props.searchSite)}
            id="font-SCD5"
          >
            최저가 확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default RightSmallMenuBar;
